import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AutoUnsubscribe } from 'app/compartilhado/decorators/unsubscribe.decorator';
import { AgendamentoTipoEnum, GlobalService } from 'app/compartilhado/servicos/global.service';
import { PopUpService } from 'app/compartilhado/componentes/pop-up/pop-up.service';
import { OwsAuthorization, CryptoUtil } from 'ows-library';
import { Subscription } from 'rxjs';
import { AppConfigService2 } from 'app-config.service';
import { environment } from 'environments/environment';
import { PagamentoService } from './pagamento.service';

declare const Iugu: any;
declare const $: any; // jquery

@Component({
  selector: 'app-pagamento-form',
  templateUrl: './pagamento-form.component.html',
  styleUrls: ['./pagamento-form.component.css']
})

@AutoUnsubscribe
export class PagamentoFormComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('inputToken') inputToken: ElementRef;
  @Input() exibirPagina = true;
  pagamentoForm: FormGroup;
  subsRetorno: Subscription;
  vistoriaValor: string;
  isAtribuidoAccountId = false;
  modoTeste = true;
  contador = 0;
  ambienteProducao = environment.production && !environment.homologacao;
  centralizar = false;

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
    Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(private fb: FormBuilder,
    private globalService: GlobalService,
    public service: PagamentoService,
    public appConfig: AppConfigService2,
    private popUpService: PopUpService) {
  }

  ngOnInit() {
    this.vistoriaValor = `R$ ${(this.service.dadosPagamento.VistoriaValor)}`;
    if (this.popUpService.agendamentoTipo === AgendamentoTipoEnum.PI) {
      this.centralizar = false;
    } else if (this.popUpService.agendamentoTipo === AgendamentoTipoEnum.GO){
      this.centralizar = true;
    }

    // Todos os timeout são necessários para o Iugu.Setup processar os campos com o formatter.min.js
    this.subsRetorno = this.service.creditoFormChanged.subscribe(resposta => {
      setTimeout(() => {
        Iugu.setup();
        if (this.ambienteProducao) {
          this.modoTeste = this.appConfig.iuguTestMode;
        }
        Iugu.setTestMode(this.modoTeste);
        
      }, 500);
      
    });
    
    this.pagamentoForm = this.fb.group({
      Token: [null]
    });
    
  }

  ngAfterViewInit() {
    Iugu.setup();
    if (this.ambienteProducao) {
      this.modoTeste = this.appConfig.iuguTestMode;
    }
    Iugu.setTestMode(this.modoTeste);
  }

  ngOnDestroy() {
  }

  onConfirmarPagamentoCartao() {
    this.globalService.exibirLoadingPagamento(true);
    let tokenValor = this.inputToken.nativeElement.value;

    if (this.isAtribuidoAccountId && tokenValor !== '') {
      this.contador = 0;
      if (tokenValor.indexOf('invalid') !== -1) {
        this.verificarErros(tokenValor);
        return;
      }

      if (tokenValor.indexOf('not found') !== -1) {
        this.limparValores();
        this.popUpService.showCustomPopWarning('Atenção!', 'Não foi possível prosseguir com o pagamento, favor entrar em contato com o local de vistoria.');
        return;
      }

      if (tokenValor.indexOf('timeout') !== -1) {
        this.limparValores();
        this.popUpService.showCustomPopWarning('Atenção!', 'Não foi possível prosseguir com o pagamento, favor entrar em contato com o local de vistoria.');
        return;
      }
      
      setTimeout(() => {
        if (this.service.pesquisaFlag) {
          return
        }
        this.service.exibePaginaPagamento = false;
        this.limparValores();
        this.service.cartaoCreditoTokenId = tokenValor;
        this.service.pesquisaFlag = true;
        this.service.efetuarPagamentoCreditoIugu('C');
        return;
      }, 500);
    }

    if (!this.isAtribuidoAccountId && tokenValor === '') {
      //AccontID do cliente.
      Iugu.setAccountID(CryptoUtil.decrypt(this.service.provedorCobrancaChave, this.service.dadosPagamento.AgendamentoId, this.service.dadosPagamento.EmpresaId));
      Iugu.setTestMode(this.modoTeste);

      $('#payment-form').submit(function(evt) {
        var form = $(this);
        var tokenResponseHandler = function(data) {
            
            if (data.errors) {
              $("#token").val(JSON.stringify(data.errors));
              return;
            } else {
                let encoded = OwsAuthorization.encodeBase64(data.id);
                $("#token").val(encoded);
            }
        }
        
        Iugu.createPaymentToken(this, tokenResponseHandler);
      });
    }

    //Token do cartão de crédito gerado pela IUGU.
    tokenValor = this.inputToken.nativeElement.value;
    if (tokenValor === '') {
      this.isAtribuidoAccountId = true;
      setTimeout(() => {
        this.contador ++;
        // Encerrar ciclo no caso de erro no accountId
        if (this.contador > 3) {
          this.contador = 0;
          return;
        }

        this.onConfirmarPagamentoCartao();
      }, 500);
    }
  }

  verificarErros(mensagemErro) {
    const valicadaoErroIugu = JSON.parse(mensagemErro);
    this.limparValores();

    if (valicadaoErroIugu.number) {
      this.popUpService.showCustomPopWarning('Atenção!', 'Número de cartão inválido. Por favor verifique os dados inseridos ou use um cartão diferente.');
      return;
    }

    if (valicadaoErroIugu.verification_value) {
      this.popUpService.showCustomPopWarning('Atenção!', 'Código de verificação inválido. Por favor verifique os dados inseridos.');
      return;
    }

    if (valicadaoErroIugu.expiration) {
      this.popUpService.showCustomPopWarning('Atenção!', 'Data de vencimento inválida. Por favor verifique os dados inseridos.');
      return;
    }

    if (valicadaoErroIugu.first_name) {
      this.popUpService.showCustomPopWarning('Atenção!', 'Nome do titular inválido. O nome do titular deve ser escrito conforme impresso no cartão, por favor verifique os dados inseridos.');
      return;
    }

    if (valicadaoErroIugu.last_name) {
      this.popUpService.showCustomPopWarning('Atenção!', 'Nome do titular inválido. O nome do titular deve ser escrito conforme impresso no cartão, por favor verifique os dados inseridos.');
      return;
    }

    if (valicadaoErroIugu.record_invalid) {
      this.popUpService.showCustomPopWarning('Atenção!', 'A empresa escolhida não aceita pagamento via cartão de crédito. Por favor selecione outro meio de pagamento.');
      return;
    }

    this.popUpService.showCustomPopWarning('Atenção!', 'Dados inválidos. Por favor verifique os dados inseridos ou selecione outro meio de pagamento.');
    return;
  }

  limparValores() {
    this.isAtribuidoAccountId = false;
    this.inputToken.nativeElement.value = '';
    this.globalService.exibirLoadingPagamento(false);
  }

  // Evento que compara a resolução da tela e retorna se é Mobile ou não
  isMobile() {
    return this.globalService.isMobile();
  }
}